/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {postEscalationTicketComment} from '../api'

export const useMutationPostEscalationTicketComment = createReactQueryMutationHook('postEscalationTicketComment', postEscalationTicketComment)
